import { useCallback, useRef, useState } from 'react';
import type { SetStateAction } from 'react';

/** Event-driven settings updates must queue persistence once, outside React updaters. */
export function useDocumentSettingsState<T>(initial: T) {
  const [state, setState] = useState(initial);
  const ref = useRef(state);
  const update = useCallback((next: SetStateAction<T>) => {
    const value = typeof next === 'function' ? (next as (previous: T) => T)(ref.current) : next;
    ref.current = value;
    setState(value);
  }, []);
  return [state, update, ref] as const;
}
